import script from "./CableSpecs.vue?vue&type=script&setup=true&lang=ts"
export * from "./CableSpecs.vue?vue&type=script&setup=true&lang=ts"

import "./CableSpecs.vue?vue&type=style&index=0&id=1471d65d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1471d65d"]])

export default __exports__